export default __webpack_public_path__ + "static/Resume-dc24c19d7077a8f97becc96d77b27809.pdf";